import ProfileImage2 from "../assets/images/RashmiS.JPG";
import classes from "../styles/AboutMe.module.css";

export default function AboutPage() {
  return (
    <div className={classes["about-page"]}>
      <div className={classes["about-page-container"]}>
        <div className={classes["about-page-image"]}>
          <img src={ProfileImage2} alt="my Profile" />
        </div>
        <div className={classes["about-page-content"]}>
          <h2>The ME!</h2>
          <h1>Person behind the code</h1>
          <p>
            <span>Rajalakshmi Sudhakar,</span> creative mind with a passion for
            coding. As a Web Developer, I thrive in combining creativity and
            technical expertise to bring ideas to life.
            <br />
            I specialize inReact.js, Redux, JavaScript, TypeScript, HTML, CSS,
            and modern web technologies, with a strong foundation in C/C++
            programming. Bringing over 4+ years of experience in the telecom
            industry.
            <br />I am passionate about learning new technologies and
            continuously refining my technical skills. I have a proven ability
            to troubleshoot and resolve real-time customer issues under
            high-pressure situations with a composed and solution-oriented
            approach. My strong problem-solving, debugging, and Agile
            methodology skills are complemented by recent hands-on experience in
            building user-centric, high-quality web applications with full-stack
            capabilities.
          </p>
          <h4>Skills:</h4>
          <div className={classes["about-btns"]}>
            <div className={classes.box}>HTML-5</div>
            <div className={classes.box}>CSS3/SCSS</div>
            <div className={classes.box}>JavaScript</div>
            <div className={classes.box}>React-JS</div>
            <div className={classes.box}>Redux Toolkit</div>
            <div className={classes.box}>TailwindCSS</div>
            <div className={classes.box}>Jest</div>
            <div className={classes.box}>Next.js</div>
            <div className={classes.box}>C/C++</div>
            <div className={classes.box}>Figma</div>
          </div>
        </div>
      </div>
    </div>
  );
}
